import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var Swarm = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return /*#__PURE__*/React.createElement(StyledIconBase, _extends({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 20 20"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.286 18.821a23.855 23.855 0 01-3.677-.923 58.46 58.46 0 01-1.007-.37.558.558 0 01-.317-.71c.086-.225.379-.949.399-.994.4-.92 1-2.153 1.795-3.379a9.16 9.16 0 002.807 6.376zm-.113-11.794C7.382 1.338 1.183 1.541.205 4.084c-.751 1.952 2.535 6.602 10.097 3.244l.004-.002a4.237 4.237 0 01-.133-.299zm1.387-.222l.002-.001c4.271-1.897 3.674-5.191 2.569-5.614-1.487-.569-4.19 1.624-2.647 5.447.015.027.066.14.076.168zm7.853 4.165A5.567 5.567 0 0016.2 7.986a1.243 1.243 0 00-.423-.073c-.717 0-1.407.595-1.472 1.338-.109 1.239.137 2.501.68 3.718.535 1.199 1.294 2.213 2.27 2.957.254.194.565.285.875.285.559 0 1.117-.296 1.339-.826a5.542 5.542 0 00-.056-4.415zm-3.241 6.369c-1.195-.912-2.142-2.139-2.815-3.646-.682-1.529-.961-3.075-.827-4.596.037-.423.161-.831.36-1.204l-.114.028a5.86 5.86 0 00-1.778.784c-.784.514-1.475 1.277-1.772 2.177-.08.243-.141.51-.161.765a7.54 7.54 0 00.636 3.67 7.562 7.562 0 002.213 2.853c.566.447 1.586.73 2.42.73.783 0 1.556-.233 2.25-.585.217-.11.695-.408.726-.429a3.17 3.17 0 01-1.138-.547z"
  }));
});
Swarm.displayName = 'Swarm';
export var SwarmDimensions = {
  height: 20,
  width: 20
};